import React from 'react';
import PaymentPlatforms from 'components/payment-platforms';
import ContactInfo from 'components/contact-info';
import AmigosMenu from './amigos-menu';
import PropTypes from 'prop-types';

export default function FooterHead({ facet, tabIndex }) {
    if (facet === 'lite') {
        return (
            <aside className="footer-head grid--row">
                <div className="footer-head--col grid--col">
                    <ContactInfo tabIndex={tabIndex} />
                </div>
                <div className="footer-head--col grid--col" />
                <div className="footer-head--col grid--col">
                    <PaymentPlatforms />
                </div>
            </aside>
        );
    }
    return (
        <aside className="footer-head grid--row">
            <div className="footer-head--col grid--col">
                <AmigosMenu tabIndex={tabIndex} />
            </div>
            <div className="footer-head--col grid--col">
                <ContactInfo tabIndex={tabIndex} />
            </div>
            <div className="footer-head--col grid--col">
                <PaymentPlatforms tabIndex={tabIndex} />
            </div>
        </aside>
    );
}

FooterHead.propTypes = {
    tabIndex: PropTypes.number.isRequired,
    facet: PropTypes.string.isRequired,
};

FooterHead.defaultProps = {
    facet: 'default',
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-footer/footer-head/index.js